import 'shared/lib/react-i18next';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { init as initErrorTracking } from 'shared/services/error-tracking';
import { enforceAppDomain } from 'shared/utils/enforce-app-domain';

import { App } from './app';

initErrorTracking();
enforceAppDomain();

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
